type BadgeVariant = "green" | "yellow" | "red" | "blue" | "gray";

interface BadgeProps {
  variant?: BadgeVariant;
  children: React.ReactNode;
}

const COLORS: Record<BadgeVariant, string> = {
  green: "bg-green-900/50 text-green-300 border-green-700",
  yellow: "bg-yellow-900/50 text-yellow-300 border-yellow-700",
  red: "bg-red-900/50 text-red-300 border-red-700",
  blue: "bg-blue-900/50 text-blue-300 border-blue-700",
  gray: "bg-gray-800 text-gray-300 border-gray-600",
};

export function Badge({ variant = "gray", children }: BadgeProps) {
  return (
    <span
      className={`inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium ${COLORS[variant]}`}
    >
      {children}
    </span>
  );
}
